import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const productionQueueApi = createApi({
  reducerPath: 'productionQueueApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['ProductionQueue'],
  endpoints: (builder) => ({
    getQueueItems: builder.query<unknown[], void>({
      query: () => 'production-lines/queue',
      providesTags: ['ProductionQueue'],
    }),
    setPriority: builder.mutation<unknown, { id: string; priority: number }>({
      query: ({ id, priority }) => ({
        url: `production-lines/queue/${id}/priority`,
        method: 'PUT',
        body: { priority },
      }),
      invalidatesTags: ['ProductionQueue'],
    }),
    startProduction: builder.mutation<unknown, string>({
      query: (id) => ({
        url: `production-lines/queue/${id}/start`,
        method: 'POST',
      }),
      invalidatesTags: ['ProductionQueue'],
    }),
    pauseProduction: builder.mutation<unknown, string>({
      query: (id) => ({
        url: `production-lines/queue/${id}/pause`,
        method: 'POST',
      }),
      invalidatesTags: ['ProductionQueue'],
    }),
    completeProduction: builder.mutation<unknown, string>({
      query: (id) => ({
        url: `production-lines/queue/${id}/complete`,
        method: 'POST',
      }),
      invalidatesTags: ['ProductionQueue'],
    }),
  }),
});

export const {
  useGetQueueItemsQuery,
  useSetPriorityMutation,
  useStartProductionMutation,
  usePauseProductionMutation,
  useCompleteProductionMutation,
} = productionQueueApi;
